/** HScrollBar registration: parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseHScrollBar } from './parser';
const hScrollBarRegistration = {
    typeName: 'HScrollBar',
    parser: parseHScrollBar,
};
nodeRegistry.register(hScrollBarRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map